import { defineComponent, reactive, ref, watch } from 'vue';
import Datepicker from 'vue3-date-time-picker';
import moment from 'moment-timezone';
import { useModelWrapper, DateHelper } from '@hems/util';
export default defineComponent({
    name: 'MonthPicker',
    components: {
        Datepicker,
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const state = reactive({
            open: useModelWrapper(props, emit, 'open'),
            value: getInitialValue(props.type),
        });
        const datePickerRef = ref(null);
        function getInitialValue(type) {
            switch (type) {
                case 'start':
                    return {
                        year: moment(props.modelValue.start).year(),
                        month: moment(props.modelValue.start).month(),
                    };
                case 'end':
                    return {
                        year: moment(props.modelValue.end).year(),
                        month: moment(props.modelValue.end).month(),
                    };
            }
        }
        function convertToDate(value) {
            const momentValue = moment().year(value.year).month(value.month);
            switch (props.type) {
                case 'start':
                    return momentValue.startOf('month').startOf('day').toDate();
                case 'end':
                    return momentValue.endOf('month').endOf('day').toDate();
                default:
                    return momentValue.toDate();
            }
        }
        function getModifiedDate() {
            switch (props.type) {
                case 'start':
                    return {
                        start: convertToDate(state.value),
                        end: props.modelValue.end,
                    };
                case 'end':
                    return {
                        start: props.modelValue.start,
                        end: convertToDate(state.value),
                    };
            }
        }
        function getMaxRangeFromSelectedMonth() {
            switch (props.type) {
                case 'start':
                    return {
                        start: convertToDate(state.value),
                        end: convertToDate({
                            year: state.value.year,
                            month: state.value.month + 11,
                        }),
                    };
                case 'end':
                    return {
                        start: convertToDate({
                            year: state.value.year,
                            month: state.value.month - 11,
                        }),
                        end: convertToDate(state.value),
                    };
            }
        }
        const validateRange = (value) => {
            if (value.start.getTime() > value.end.getTime() || DateHelper.getRangeMonth(getModifiedDate()) >= 12) {
                apply(getMaxRangeFromSelectedMonth());
                return;
            }
            apply(value);
        };
        const close = () => {
            emit('close');
        };
        const apply = (modifiedDate) => {
            emit('update:modelValue', modifiedDate);
            close();
        };
        const ok = () => {
            selectDatePicker();
            validateRange(getModifiedDate());
        };
        const selectDatePicker = () => {
            datePickerRef?.value?.selectDate();
        };
        watch(() => props.open, () => {
            if (props.open) {
                state.value = getInitialValue(props.type);
            }
        });
        return {
            state,
            ok,
            close,
            datePickerRef,
        };
    },
});
